import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router';

import StudentListRow from './StudentListRow';
import { studentPermission } from '../../utils/helpers';

const StudentsList = ({ students, user, history }) => {
  const onSelectStudent = (student) => {
    if (studentPermission(user, student)) {
      history.push(`/alumnos/${student.id}/basica`);
    }
  };

  return (
    <div>
      <div className="columns-container">
        <span># MATRICULA</span>
        <span>NOMBRE</span>
        <span>APELLIDO</span>
        <span className="conditional-column">CICLO</span>
        <span className="conditional-column">CLASE</span>
      </div>
      {_.isEmpty(students) &&
        <div className="empty-state">No se encontraron alumnos</div>
      }
      {!_.isEmpty(students) && students.map(student =>
        <StudentListRow
          key={student.id}
          {...student}
          onSelect={() => onSelectStudent(student)}
        />
      )}
    </div>
  );
};

const { array, object } = PropTypes;

StudentsList.propTypes = {
  history: object.isRequired,
  students: array,
  user: object
};

const mapState = state => ({
  user: state.getIn(['session', 'user']).toJS()
});

export default withRouter(connect(mapState)(StudentsList));



// WEBPACK FOOTER //
// ./src/components/student/StudentsList.js